import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-bct-price-verify-modal',
    imports: [],
    templateUrl: './bct-price-verify-modal.component.html',
    styleUrl: './bct-price-verify-modal.component.scss'
})
export class BctPriceVerifyModalComponent {

  @Input() requestId: string = null;
  @Input() payerCardNumber: string = null;

  constructor(private activeModal: NgbActiveModal){}

  closeModal(payerCardNumber: string){
    if(payerCardNumber !== null){
      console.log("Inside Modal:", payerCardNumber);
      this.activeModal.close(payerCardNumber);
    } else {
      this.activeModal.dismiss();
    }
  }
}
